import React from 'react';
import { connect } from 'react-redux';
import {Page, PageActions, Layout, Card, FormLayout, TextField, Button, TextContainer, Heading, TextStyle} from '@shopify/polaris';
import Trix from "trix";
import AdvancedColorPicker from './AdvancedColorPicker'
import createApp from '@shopify/app-bridge';
import { ResourcePicker } from '@shopify/app-bridge-react';
import { Toast } from '@shopify/app-bridge/actions';
import { getSessionToken } from "@shopify/app-bridge-utils";
import { settingsAction } from '../../actions/settings';
import { onWallConfigChange, onWallConfigCollectionChange } from '../../actions/wall_config';
import { addBackground, onBackgroundChange, updateBackground, deleteBackground } from '../../actions/backgrounds';
import { addFrame, onFrameChange, updateFrame, deleteFrame } from '../../actions/frames';
import { addFaq, onFaqChange, updateFaq, deleteFaq } from '../../actions/faqs';
import axios from 'axios';


class Index extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      changed: false,
      pickCollections: false,
      pickFrameProduct: null,
      showSuccessToast: false,
      showErrorToast: false,
      successToastMessage: "Settings updated",
      errorToastMessage: "There was a problem saving the settings"
    }
  }

  componentDidMount() {
    let _this = this;
    let csrfToken = document.getElementsByName('csrf-token')[0].getAttribute('content');
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

    // Intercept all requests on this Axios instance
    axios.interceptors.request.use(function (config) {
      return getSessionToken(window.app) // requires a Shopify App Bridge instance
        .then((token) => {
          // Append your request headers with an authenticated token
          config.headers["Authorization"] = `Bearer ${token}`;
          return config;
        });
    });

    // Trix editor
    document.addEventListener('trix-change', event => {
      _this.onConfigChange("insp_text", event.target.innerHTML)
    })
  }

  onConfigChange(key, value) {
    this.props.onWallConfigChange(key, value)
    this.setState({
      changed: true
    })
  }

  onConfigCollectionChange(index, key, value) {
    this.props.onWallConfigCollectionChange(index, key, value)
    this.setState({
      changed: true
    })
  }

  addBackground() {
    console.log('Add background');
    this.props.addBackground(this.props.appDomain, this.props.shop.id);
    this.setState({
      changed: true
    })
  }

  onBackgroundChange(index, key, value) {
    console.log('on background change', index, key, value);
    this.props.onBackgroundChange(index, key, value)
    this.setState({
      changed: true
    })
  }

  addBackgroundColor(index) {
    console.log('Add background color: ', index);
    let background = this.props.backgrounds[index];
    let newColor = {
      "src": "",
      "color": "",
      "title": ""
    }
    background.colors.push(newColor);
    this.props.updateBackground(this.props.appDomain, background);
    this.setState({
      changed: true
    })
  }

  onBackgroundColorChange(colorIndex, index, key, value) {
    console.log('Background color change');
    let colors = this.props.backgrounds[index].colors;
    colors[colorIndex][key] = value;
    this.props.onBackgroundChange(index, 'colors', colors);
    this.setState({
      changed: true
    })
  }

  deleteBackgroundColor(colorIndex, index) {
    console.log(index, colorIndex);
    let background = this.props.backgrounds[index];
    background.colors.splice(colorIndex, 1);
    this.props.updateBackground(this.props.appDomain, background);
    this.setState({
      changed: true
    })
  }

  addFrame() {
    console.log('Add frame');
    this.props.addFrame(this.props.appDomain, this.props.shop.id);
    this.setState({
      changed: true
    })
  }

  onFrameChange(index, key, value) {
    console.log('on frame change', index, key, value);
    this.props.onFrameChange(index, key, value)
    this.setState({
      changed: true
    })
  }

  onFrameProductSelectStart(index) {
    this.setState({
      pickFrameProduct: index
    })
  }

  onFrameProductSelect(selection) {
    let selectedProduct = selection.selection[0];
    let index = this.state.pickFrameProduct;
    this.onFrameChange(index, 'product_data', selectedProduct);
    this.setState({
      pickFrameProduct: null
    })
  }

  onFrameProductSelectCancel() {
    this.setState({
      pickFrameProduct: null
    })
  }

  addFaq() {
    console.log('Add faq');
    this.props.addFaq(this.props.appDomain, this.props.shop.id);
    this.setState({
      changed: true
    })
  }

  onFaqChange(index, key, value) {
    this.props.onFaqChange(index, key, value)
    this.setState({
      changed: true
    })
  }

  onCollectionSelectStart() {
    this.setState({
      pickCollections: true
    })
  }

  onCollectionSelect(selection) {
    let selectedCollections = selection.selection
    console.log(selection.selection)
    let collections = selectedCollections.map((collection, index) => {
      return(
        {
          "id": collection.handle,
          "title": collection.title,
          "gid": collection.id.split("/")[collection.id.split("/").length - 1],
          "position": (index + 1).toString()
        }
      )
    })
    this.props.onWallConfigChange("collections", collections);
    this.setState({
      changed: true
    })
  }

  onCollectionSelectCancel() {
    this.setState({
      pickCollections: false
    })
  }

  onSave() {
    console.log('SAVE');
    this.onSaveWallConfig();
    this.onSaveBackgrounds();
    this.onSaveFrames();
    this.onSaveFaqs();
    // Save frames
    this.setState({
      changed: false
    })
  }

  onSaveWallConfig = () => {
    let _this = this;
    var url = "https://" + this.props.appDomain + "/v1/wall_configs/" + this.props.wallConfig.id;
    axios.put(url,
      {
        wall_config: this.props.wallConfig
      }
    )
    .then(response => {
      if(response.data.success == true) {
        this.setState({
          showSuccessToast: true,
          showErrorToast: false,
        })
      } else {
        this.setState({
          showSuccessToast: false,
          showErrorToast: true,
        })
      }
    })
    .catch(function(error) {
      console.log('Axios error: ', error);
      this.setState({
        showSuccessToast: false,
        showErrorToast: true
      })
    });
  }

  onSaveBackgrounds = () => {
    let _this = this;
    var url = "https://" + this.props.appDomain + "/v1/backgrounds/bulk_update";
    axios.put(url,
      {
        backgrounds: this.props.backgrounds
      }
    )
    .then(response => {
      if(response.data.success == true) {
        this.setState({
          showSuccessToast: true,
          showErrorToast: false,
        })
      } else {
        this.setState({
          showSuccessToast: false,
          showErrorToast: true,
        })
      }
    })
    .catch(function(error) {
      console.log('Axios error: ', error);
      this.setState({
        showSuccessToast: false,
        showErrorToast: true
      })
    });
  }

  onSaveFrames = () => {
    let _this = this;
    var url = "https://" + this.props.appDomain + "/v1/frames/bulk_update";
    axios.put(url,
      {
        frames: this.props.frames
      }
    )
    .then(response => {
      if(response.data.success == true) {
        this.setState({
          showSuccessToast: true,
          showErrorToast: false,
        })
      } else {
        this.setState({
          showSuccessToast: false,
          showErrorToast: true,
        })
      }
    })
    .catch(function(error) {
      console.log('Axios error: ', error);
      this.setState({
        showSuccessToast: false,
        showErrorToast: true
      })
    });
  }

  onSaveFaqs = () => {
    let _this = this;
    var url = "https://" + this.props.appDomain + "/v1/faqs/bulk_update";
    axios.put(url,
      {
        faqs: this.props.faqs
      }
    )
    .then(response => {
      if(response.data.success == true) {
        this.setState({
          showSuccessToast: true,
          showErrorToast: false,
        })
      } else {
        this.setState({
          showSuccessToast: false,
          showErrorToast: true,
        })
      }
    })
    .catch(function(error) {
      console.log('Axios error: ', error);
      this.setState({
        showSuccessToast: false,
        showErrorToast: true
      })
    });
  }

  onToastDismiss = () => {
    this.setState({
      showSuccessToast: false,
      showErrorToast: false
    })
  }


  render() {
    let currentBackgrounds;
    currentBackgrounds = this.props.backgrounds.map((background, index) => {
      let colors = background.colors.map((color, colorIndex) => {
        return(
          <FormLayout key={"color - " + index + " - " + colorIndex}>
            <FormLayout.Group>
              <TextField
                label="Title"
                value={color.title}
                onChange={this.onBackgroundColorChange.bind(this, colorIndex, index, "title")}
              />
              <AdvancedColorPicker
                fieldKey={'color-picker' + index + '-' + colorIndex}
                label="Color"
                color={color.color}
                onChange={this.onBackgroundColorChange.bind(this, colorIndex, index, "color")}
                onColorSelect={this.onBackgroundColorChange.bind(this, colorIndex, index, "color")}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Image"
                value={color.src}
                onChange={this.onBackgroundColorChange.bind(this, colorIndex, index, "src")}
              />
            </FormLayout.Group>
            <Button plain destructive onClick={this.deleteBackgroundColor.bind(this, colorIndex, index)}>Delete</Button>
            <br />
          </FormLayout>
        )
      })

      let colorsTitle;
      if(colors.length) {
        colorsTitle = (
          <React.Fragment>
            <br />
            <h3 className="Polaris-Subheading"><b>Colors:</b></h3>
          </React.Fragment>
        )
      }

      return(
        <Card.Section
          key={"background - " + background.id} title={background.title}
          actions={[
            {
              content: 'Add Color',
              onAction: () => this.addBackgroundColor(index)
            },
            {
              content: 'Delete background',
              destructive: true,
              onAction: () => this.props.deleteBackground(this.props.appDomain, background)
            }
          ]}
        >
          <TextField
            label="Title"
            value={background.title}
            onChange={this.onBackgroundChange.bind(this, index, "title")}
          />
          <TextField
            label="Image"
            value={background.src}
            onChange={this.onBackgroundChange.bind(this, index, "src")}
          />
          <TextField
            label="Image alt"
            value={background.alt}
            onChange={this.onBackgroundChange.bind(this, index, "alt")}
          />
          <div style={{paddingLeft: 20, paddingRight: 20}}>
            <Card.Subsection>
              {colorsTitle}
              {colors}
            </Card.Subsection>
          </div>
        </Card.Section>
      )
    })

    let dropdownCollections;
    dropdownCollections = this.props.wallConfig.collections.map((collection, index) => {
      return(
        <div key={"collection-" + collection.id} className="collection-wrapper">
          <h4 className="collection-wrapper__title">{collection.title}</h4>
          <TextField
            label="Position"
            type="number"
            value={collection.position}
            onChange={this.onConfigCollectionChange.bind(this, index, 'position')}
          />
        </div>
      )
    })

    let currentFrames;
    currentFrames = this.props.frames.map((frame, index) => {
      let title;
      if(frame.product_data != null) {
        title = "Current product: " + frame.product_data.title;
      }
      return(
        <Card.Section
          key={"frame - " + frame.id} title={frame.title}
          actions={[
            {
              content: 'Delete frame',
              destructive: true,
              onAction: () => this.props.deleteFrame(this.props.appDomain, frame)
            }
          ]}
        >
          <FormLayout>
              <TextField
                label="Title"
                value={frame.title}
                onChange={this.onFrameChange.bind(this, index, "title")}
              />
              <TextField
                label="Image"
                value={frame.src}
                onChange={this.onFrameChange.bind(this, index, "src")}
              />
          </FormLayout>
          <br />
          <FormLayout>
            <TextContainer><Heading element="h3">{title}</Heading></TextContainer>
            <Button primary onClick={this.onFrameProductSelectStart.bind(this, index)}>Select Product</Button>
          </FormLayout>
        </Card.Section>
      )
    })


    let collectionIds;
    collectionIds = this.props.wallConfig.collections.map((collection) => {
      let gid = "gid://shopify/Collection/" + collection.gid;
      return gid
    })

    let currentFaqs;
    currentFaqs = this.props.faqs.map((faq, index) => {
      return(
        <Card.Section
          key={"faq - " + faq.id}
          title={faq.question}
          actions={[
            {
              content: 'Delete faq',
              destructive: true,
              onAction: () => this.props.deleteFaq(this.props.appDomain, faq, index)
            }
          ]}
        >
          <TextField
            label="Question"
            value={faq.question}
            onChange={this.onFaqChange.bind(this, index, "question")}
          />
          <TextField
            label="Answer"
            value={faq.answer}
            onChange={this.onFaqChange.bind(this, index, "answer")}
          />
        </Card.Section>
      )
    })


    let resourcePicker;
    if(this.state.pickCollections) {
      resourcePicker = (
        <ResourcePicker
          resourceType="Collection"
          open={true}
          allowMultiple={true}
          showHidden={true}
          onSelection={this.onCollectionSelect.bind(this)}
          onCancel={this.onCollectionSelectCancel.bind(this)}
        />
      )
    } else if(this.state.pickFrameProduct != null) {
      resourcePicker = (
        <ResourcePicker
          resourceType="Product"
          open={true}
          allowMultiple={false}
          showHidden={true}
          showVariants={false}
          onSelection={this.onFrameProductSelect.bind(this)}
          onCancel={this.onFrameProductSelectCancel.bind(this)}
        />
      )
    }

    let successToastOptions = {
      message: this.state.successToastMessage,
      duration: 5000,
      isError: false
    }
    const successToast = Toast.create(window.app, successToastOptions);

    let errorToastOptions = {
      message: this.state.errorToastMessage,
      duration: 5000,
      isError: true
    }
    const errorToast = Toast.create(window.app, errorToastOptions);

    this.state.showSuccessToast ?  successToast.dispatch(Toast.Action.SHOW) : null;
    this.state.showErrorToast ?  errorToast.dispatch(Toast.Action.SHOW) : null;

    return(
      <Page title="Image wall configuration"
      >
        <PageActions
          primaryAction={{
            content: "Save",
            onAction: () => {this.onSave()},
          }}
        />
        <Layout>
          <Layout.Section>
            <Card title="General Settings">
              <Card.Section>
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Page title"
                      value={this.props.wallConfig.page_title}
                      onChange={this.onConfigChange.bind(this, "page_title")}
                    />
                    <TextField
                      label="Logo url"
                      value={this.props.wallConfig.logo_url}
                      onChange={this.onConfigChange.bind(this, "logo_url")}
                    />
                    <TextField
                      label="Clerk public key"
                      value={this.props.wallConfig.search_key}
                      onChange={this.onConfigChange.bind(this, "search_key")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
            </Card>
            <Card title="Text options">
              <Card.Section title="General text settings">
                <FormLayout>
                  <FormLayout.Group condensed>
                    <TextField
                      label="Next button text"
                      value={this.props.wallConfig.next_btn_text}
                      onChange={this.onConfigChange.bind(this, "next_btn_text")}
                    />
                    <TextField
                      label="Back button text"
                      value={this.props.wallConfig.back_btn_text}
                      onChange={this.onConfigChange.bind(this, "back_btn_text")}
                    />
                    <TextField
                      label="Add button text"
                      value={this.props.wallConfig.add_btn_text}
                      onChange={this.onConfigChange.bind(this, "add_btn_text")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group condensed>
                    <TextField
                      label="Exit button text"
                      value={this.props.wallConfig.exit_btn_text}
                      onChange={this.onConfigChange.bind(this, "exit_btn_text")}
                    />
                    <TextField
                      label="Save button text"
                      value={this.props.wallConfig.save_btn_text}
                      onChange={this.onConfigChange.bind(this, "save_btn_text")}
                    />
                    <TextField
                      label="Remove button text"
                      value={this.props.wallConfig.remove_btn_text}
                      onChange={this.onConfigChange.bind(this, "remove_btn_text")}
                    />
                    <TextField
                      label="No frame text"
                      value={this.props.wallConfig.no_frame}
                      onChange={this.onConfigChange.bind(this, "no_frame")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Warning popup title"
                      value={this.props.wallConfig.warning_title}
                      onChange={this.onConfigChange.bind(this, "warning_title")}
                    />
                    <TextField
                      label="Warning popup text"
                      multiline={3}
                      value={this.props.wallConfig.warning_text}
                      onChange={this.onConfigChange.bind(this, "warning_text")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Warning popup continue"
                      value={this.props.wallConfig.warning_continue}
                      onChange={this.onConfigChange.bind(this, "warning_continue")}
                    />
                    <TextField
                      label="Warning popup cancel"
                      value={this.props.wallConfig.warning_cancel}
                      onChange={this.onConfigChange.bind(this, "warning_cancel")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="Top menu bar">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Help button text"
                      value={this.props.wallConfig.help_btn_text}
                      onChange={this.onConfigChange.bind(this, "help_btn_text")}
                    />
                    <TextField
                      label="Help button url"
                      value={this.props.wallConfig.help_btn_url}
                      onChange={this.onConfigChange.bind(this, "help_btn_url")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Inspiration button text"
                      value={this.props.wallConfig.insp_btn_text}
                      onChange={this.onConfigChange.bind(this, "insp_btn_text")}
                    />
                    <TextField
                      label="Inspiration button url"
                      value={this.props.wallConfig.insp_btn_url}
                      onChange={this.onConfigChange.bind(this, "insp_btn_url")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="Bottom menu bar">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Create button text"
                      value={this.props.wallConfig.create_btn_text}
                      onChange={this.onConfigChange.bind(this, "create_btn_text")}
                    />
                    <TextField
                      label="Share button text"
                      value={this.props.wallConfig.share_btn_text}
                      onChange={this.onConfigChange.bind(this, "share_btn_text")}
                    />
                    <TextField
                      label="Add wall to cart text"
                      value={this.props.wallConfig.add_wall_to_cart_text}
                      onChange={this.onConfigChange.bind(this, "add_wall_to_cart_text")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="Share popup">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Share popup title"
                      value={this.props.wallConfig.share_title}
                      onChange={this.onConfigChange.bind(this, "share_title")}
                    />
                    <TextField
                      label="Share popup content"
                      value={this.props.wallConfig.share_content}
                      onChange={this.onConfigChange.bind(this, "share_content")}
                    />
                    <TextField
                      label="Share popup button"
                      value={this.props.wallConfig.share_button_text}
                      onChange={this.onConfigChange.bind(this, "share_button_text")}
                    />
                    <TextField
                      label="Copied url text"
                      value={this.props.wallConfig.copied_text}
                      onChange={this.onConfigChange.bind(this, "copied_text")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="Add slide out text">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Size"
                      value={this.props.wallConfig.add_size_text}
                      onChange={this.onConfigChange.bind(this, "add_size_text")}
                    />
                    <TextField
                      label="Frame"
                      value={this.props.wallConfig.add_frame_text}
                      onChange={this.onConfigChange.bind(this, "add_frame_text")}
                    />
                    <TextField
                      label="Total price"
                      value={this.props.wallConfig.add_price_text}
                      onChange={this.onConfigChange.bind(this, "add_price_text")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="Cart slide out text">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Empty cart message"
                      value={this.props.wallConfig.empty_cart}
                      onChange={this.onConfigChange.bind(this, "empty_cart")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Frame"
                      value={this.props.wallConfig.cart_frame_text}
                      onChange={this.onConfigChange.bind(this, "cart_frame_text")}
                    />
                    <TextField
                      label="Remove"
                      value={this.props.wallConfig.cart_remove_text}
                      onChange={this.onConfigChange.bind(this, "cart_remove_text")}
                    />
                    <TextField
                      label="Subtotal"
                      value={this.props.wallConfig.cart_subtotal_text}
                      onChange={this.onConfigChange.bind(this, "cart_subtotal_text")}
                    />
                    <TextField
                      label="Add to cart"
                      value={this.props.wallConfig.cart_atc_text}
                      onChange={this.onConfigChange.bind(this, "cart_atc_text")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
            </Card>
            <Card title="Mobile landing page">
              <Card.Section>
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Mobile Landing page title"
                      value={this.props.wallConfig.mobile_title}
                      onChange={this.onConfigChange.bind(this, "mobile_title")}
                    />
                    <TextField
                      label="Mobile Landing page button"
                      value={this.props.wallConfig.mobile_button_text}
                      onChange={this.onConfigChange.bind(this, "mobile_button_text")}
                    />
                    <TextField
                      label="Mobile Landing page button url"
                      value={this.props.wallConfig.mobile_landing_url}
                      onChange={this.onConfigChange.bind(this, "mobile_landing_url")}
                    />
                  </FormLayout.Group>
                  <TextField
                    label="Mobile Landing page content"
                    multiline={3}
                    value={this.props.wallConfig.mobile_content}
                    onChange={this.onConfigChange.bind(this, "mobile_content")}
                  />
                </FormLayout>
              </Card.Section>
            </Card>
            <Card title="Intro steps">
              <Card.Section title="step 1 & 2 background">
                <TextField
                  label="Step one and two background"
                  value={this.props.wallConfig.main_background}
                  onChange={this.onConfigChange.bind(this, "main_background")}
                />
              </Card.Section>
              <Card.Section title="step 1">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Step one title"
                      value={this.props.wallConfig.step_one_title}
                      onChange={this.onConfigChange.bind(this, "step_one_title")}
                    />
                    <TextField
                      label="Step one subtitle"
                      value={this.props.wallConfig.step_one_subtitle}
                      onChange={this.onConfigChange.bind(this, "step_one_subtitle")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Step one image"
                      value={this.props.wallConfig.step_one_image}
                      onChange={this.onConfigChange.bind(this, "step_one_image")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Step one box title"
                      value={this.props.wallConfig.step_one_box_title}
                      onChange={this.onConfigChange.bind(this, "step_one_box_title")}
                    />
                    <TextField
                      label="Step one box text"
                      multiline={3}
                      value={this.props.wallConfig.step_one_text}
                      onChange={this.onConfigChange.bind(this, "step_one_text")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="step 2">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Step two title"
                      value={this.props.wallConfig.step_two_title}
                      onChange={this.onConfigChange.bind(this, "step_two_title")}
                    />
                    <TextField
                      label="Step two subtitle"
                      value={this.props.wallConfig.step_two_subtitle}
                      onChange={this.onConfigChange.bind(this, "step_two_subtitle")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Step two image"
                      value={this.props.wallConfig.step_two_image}
                      onChange={this.onConfigChange.bind(this, "step_two_image")}
                   />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="step 3">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Step three title"
                      value={this.props.wallConfig.step_three_title}
                      onChange={this.onConfigChange.bind(this, "step_three_title")}
                    />
                    <TextField
                      label="Step three subtitle"
                      value={this.props.wallConfig.step_three_subtitle}
                      onChange={this.onConfigChange.bind(this, "step_three_subtitle")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Step three image"
                      value={this.props.wallConfig.step_three_image}
                      onChange={this.onConfigChange.bind(this, "step_three_image")}
                    />
                  </FormLayout.Group>
                  <FormLayout.Group>
                    <TextField
                      label="Step three box url"
                      value={this.props.wallConfig.step_three_url}
                      onChange={this.onConfigChange.bind(this, "step_three_url")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
            </Card>

            <Card
              title="Background Selection"
              primaryFooterAction={{
                content: 'Add Background',
                onAction: () => this.addBackground()
              }}
            >
              {currentBackgrounds}
              <Card.Section>
              </Card.Section>
            </Card>

            <Card title="Wall Builder">
              <Card.Section title="Search">
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Search text"
                      value={this.props.wallConfig.search_text}
                      onChange={this.onConfigChange.bind(this, "search_text")}
                    />
                    <TextField
                      label="Search no results"
                      value={this.props.wallConfig.search_no_results}
                      onChange={this.onConfigChange.bind(this, "search_no_results")}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section title="Collections">
                <FormLayout.Group>
                  <Button primary onClick={this.onCollectionSelectStart.bind(this)}>Select Collections</Button>
                  <TextField
                    label="Placeholder text"
                    value={this.props.wallConfig.dropdown_title}
                    onChange={this.onConfigChange.bind(this, "dropdown_title")}
                    helpText="This text will replace the title of the collection in position #1"
                  />
                  <TextField
                    label="Load more text"
                    value={this.props.wallConfig.load_more_text}
                    onChange={this.onConfigChange.bind(this, "load_more_text")}
                  />
                </FormLayout.Group>
                {dropdownCollections}
              </Card.Section>
            </Card>
            <Card title="Frames"
              primaryFooterAction={{
                content: 'Add Frame',
                onAction: () => this.addFrame()
              }}
            >
              {currentFrames}
            </Card>
            <Card title="Help Modal"
              primaryFooterAction={{
                content: 'Add FAQ',
                onAction: () => this.addFaq()
              }}
            >
              <Card.Section>
                <TextField
                  label="Title"
                  value={this.props.wallConfig.help_title}
                  onChange={this.onConfigChange.bind(this, "help_title")}
                />
                {currentFaqs}
              </Card.Section>
              <Card.Section>
              </Card.Section>
            </Card>
            <Card title="Inspiration Modal">
              <Card.Section>
                <TextField
                  label="Title"
                  value={this.props.wallConfig.insp_title}
                  onChange={this.onConfigChange.bind(this, "insp_title")}
                />
                <br />
                <input
                  type="hidden"
                  id="trix"
                  value={this.props.wallConfig.insp_text}
                />
                <trix-editor input="trix" />
              </Card.Section>
            </Card>
          </Layout.Section>
        </Layout>
        {resourcePicker}
        <PageActions
          primaryAction={{
            content: "Save",
            onAction: () => {this.onSave()},
          }}
        />
      </Page>
    )
  }
}

const mapStateToProps = (state) => ({
  shop: state.shop,
  appName: state.settings.appName,
  appDomain: state.settings.appDomain,
  reviewLink: state.settings.reviewLink,
  supportLink: state.settings.supportLink,
  apiKey: state.settings.apiKey,
  host: state.settings.host,
  wallConfig: state.wallConfig,
  backgrounds: state.backgrounds,
  frames: state.frames,
  faqs: state.faqs
})

const mapDispatchToProps = {
  settingsAction,
  onWallConfigChange,
  onWallConfigCollectionChange,
  addBackground,
  onBackgroundChange,
  updateBackground,
  deleteBackground,
  addFrame,
  onFrameChange,
  updateFrame,
  deleteFrame,
  addFaq,
  onFaqChange,
  updateFaq,
  deleteFaq
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);

